import PageHeader from 'components/common/PageHeader';
import { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getEstateByMatricula, getRealEstateData } from 'redux/realEstateSlice';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import ModalDeleteRE from './components/ModalDeleteRE';
import NoRealEstateCard from './components/NoRealEstateCard';
import RealEstate from './components/RealEstate';
import ButtonCreate from '../../../../utils/buttons/ButtonCreate';
import ModalCreateBO from './components/ModalCreateBO';

const EditRealEstate = () => {
  // * States
  const { realEstate, data } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();
  const params = useParams();

  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalBranchOffices, setOpenModalBranchOffices] = useState(false);

  // * Methods
  const FetchData = async () => {
    setLoading(true);
    await dispatch(getEstateByMatricula(params.id));
    setLoading(false);
  };

  // * Life Cycle
  useEffect(() => {
    FetchData();
  }, []);

  useEffect(() => {
    if (realEstate.id) {
      dispatch(getRealEstateData(realEstate.id));
    }
  }, [realEstate]);

  return (
    <>
      <PageHeader
        title={`Inmobiliaria ${realEstate?.name} - #${realEstate?.matricula}`}
        description=""
        className="mb-3 bg-white"
        col="xs-12"
      >
        {realEstate?.isActive ? (
          <span className="badge bg-success">
            <strong> Inmobiliaria Activa</strong>
          </span>
        ) : (
          <span className="badge bg-danger">
            <strong> Inmobiliaria Inactiva</strong>
          </span>
        )}
        {data?.id && realEstate?.isActive && (
          <>
            <div className="mt-5 mt-sm-4" />
            <div className="d-flex justify-content-end w-100">
              <ButtonDelete
                text="Eliminar inmobiliaria"
                funcion={() => setOpenModal(true)}
                className="bottom-0 mb-3 me-3"
              />
              <ButtonCreate
                text="Crear sucursal"
                funcion={() => setOpenModalBranchOffices(true)}
                className="bottom-0 mb-3 me-3"
              ></ButtonCreate>
            </div>
          </>
        )}
      </PageHeader>
      {loading ? (
        <Card
          className="bg-white d-flex justify-content-center align-items-center"
          style={{ height: '30vh' }}
        >
          <Spinner animation="border" variant="primary" />
        </Card>
      ) : data?.id ? (
        <RealEstate />
      ) : (
        <NoRealEstateCard />
      )}
      {openModal && (
        <ModalDeleteRE
          show={openModal}
          handleClose={() => setOpenModal(false)}
          estateName={realEstate.name}
          realEstateId={String(realEstate.id)}
        />
      )}
      {openModalBranchOffices && (
        <ModalCreateBO
          show={openModalBranchOffices}
          handleClose={() => setOpenModalBranchOffices(false)}
          realEstateId={String(realEstate.id)}
        />
      )}
    </>
  );
};

export default EditRealEstate;
